module.exports = __webpack_public_path__ + "img/news.692484eb.png";